import { SnackType } from '../enums/snack-type'
import type { Snack } from '../interfaces/snack'

export const snacks: Snack[] = [
  {
    emoji: '🎂',
    type: SnackType.SweetsAndDessert,
    name: 'Cake',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+cake',
    amount: '1 cake (~650g)',
    calories: 2251
  },
  {
    emoji: '🍰',
    type: SnackType.SweetsAndDessert,
    name: 'Slice of cake',
    link: 'https://www.wolframalpha.com/input?i=calories+in+slice+of+cake+',
    amount: '1 slice (~80g)',
    calories: 277
  },
  {
    emoji: '🍩',
    type: SnackType.SweetsAndDessert,
    name: 'Doughnut',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+doughnut&assumption=%7B%22EAC%22,+%22ExpandedFood%22,+%22Doughnut%22%7D+-%3E+%7B%7B%22Doughnut%22,+%7B%22Food:Flavor%22+-%3E+%22Food:Chocolate%22,+%22Food:Variety%22+-%3E+%22Food:CakeType%22,+%22Food:Variety%22+-%3E+%22Food:SugaredOrGlazed%22%7D%7D%7D',
    amount: '1 doughnut (~56g)',
    calories: 235
  },
  {
    emoji: '🍫',
    type: SnackType.SweetsAndDessert,
    name: 'Chocolate Bar',
    link: 'https://www.wolframalpha.com/input?i=calories+chocolate+bar',
    amount: '1 bar (~43g)',
    calories: 227
  },
  {
    emoji: '🍦',
    type: SnackType.SweetsAndDessert,
    name: 'Soft Ice Cream',
    link: 'https://www.wolframalpha.com/input?i=calories+in+soft+serve+ice+cream',
    amount: '1/2 cup (~107g)',
    calories: 188
  },
  {
    emoji: '🧁',
    type: SnackType.SweetsAndDessert,
    name: 'Cupcake',
    link: 'https://www.fatsecret.com/calories-nutrition/generic/cake-cupcake-chocolate-with-icing-or-filling?portionid=15043&portionamount=1.000',
    amount: '1 cupcake (~40g)',
    calories: 150
  },
  {
    emoji: '🍪',
    type: SnackType.SweetsAndDessert,
    name: 'Chocolate Cookie',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+cookie&assumption=%7B%22DPClash%22,+%22ExpandedFoodE%22,+%22cookie%22%7D+-%3E+%7B%22Cookie%22,+%22dflt%22%7D&assumption=%7B%22EAC%22,+%22ExpandedFood%22,+%22Cookie%22%7D+-%3E+%7B%7B%22Cookie%22,+%7B%22Food:AddedFoods%22+-%3E+%22Food:WithChocolateChips%22,+%22Food:Variety%22+-%3E+%22Food:FastFood%22%7D%7D%7D',
    amount: '1 cookie (~15g)',
    calories: 68
  },
  // {
  //   emoji: '🍭',
  //   type: SnackType.SweetsAndDessert,
  //   name: 'Lollipop',
  //   link: 'https://www.nutritionvalue.org/Lollipops_586470_nutritional_value.html',
  //   amount: '1 lollipop (~12g)',
  //   calories: 50
  // },
  // {
  //   emoji: '🍱',
  //   type: SnackType.AsianFood,
  //   name: 'Bento Box',
  //   link: 'https://www.myfitnesspal.com/food/calories/bento-box-2414565314',
  //   amount: '1 box (~552g)',
  //   calories: 639
  // },
  // {
  //   emoji: '🍜',
  //   type: SnackType.AsianFood,
  //   name: 'Japanese Ramen Bowl',
  //   link: 'https://www.nutritionix.com/i/nutritionix/japanese-ramen-1-bowl-3-cups/56aa69067e423acb2de52bd7',
  //   amount: '1 bowl (~353g)',
  //   calories: 477
  // },
  {
    emoji: '🥤',
    type: SnackType.Beverages,
    name: 'Soft Drink (Coke)',
    link: 'https://www.wolframalpha.com/input?i=calories+in+coke+bottle',
    amount: '1 drink (~350ml)',
    calories: 140
  },
  {
    emoji: '🧃',
    type: SnackType.Beverages,
    name: 'Apple Juice',
    link: 'https://www.wolframalpha.com/input?i=calories+in+apple+juice',
    amount: '1 drink (~250ml)',
    calories: 115
  },
  {
    emoji: '🍺',
    type: SnackType.Beverages,
    name: 'Beer',
    link: 'https://www.wolframalpha.com/input?i=calories+in+beer+500ml',
    amount: '1 beer (~168ml)',
    calories: 200
  },

  {
    emoji: '🥥',
    type: SnackType.Fruits,
    name: 'Coconut',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+coconut',
    amount: '1 piece (~45g)',
    calories: 159
  },
  {
    emoji: '🍌',
    type: SnackType.Fruits,
    name: 'Banana',
    link: 'https://www.wolframalpha.com/input?i=calories+in+banana',
    amount: '1 banana (~118g)',
    calories: 105
  },
  {
    emoji: '🍇',
    type: SnackType.Fruits,
    name: 'Grapes',
    link: 'https://www.wolframalpha.com/input?i=calories+in+grapes',
    amount: '1 cup (~150g)',
    calories: 97
  },
  {
    emoji: '🍐',
    type: SnackType.Fruits,
    name: 'Pear',
    link: 'https://www.wolframalpha.com/input?i=calories+in+pear',
    amount: '1 pear (~192g)',
    calories: 96
  },
  {
    emoji: '🍎',
    type: SnackType.Fruits,
    name: 'Apple',
    link: 'https://www.wolframalpha.com/input?i=calories+in+apple',
    amount: '1 apple (~182g)',
    calories: 91
  },
  {
    emoji: '🥭',
    type: SnackType.Fruits,
    name: 'Mango',
    link: 'https://www.wolframalpha.com/input?i=calories+in+mango',
    amount: '1 mango (~140g)',
    calories: 84
  },
  {
    emoji: '🫐',
    type: SnackType.Fruits,
    name: 'Blueberries',
    link: 'https://www.wolframalpha.com/input?i=calories+in+blueberries',
    amount: '1 cup (~148g)',
    calories: 84
  },
  {
    emoji: '🍍',
    type: SnackType.Fruits,
    name: 'Pineapple',
    link: 'https://www.wolframalpha.com/input?i=calories+in+pineapple',
    amount: '1 cup (~165g)',
    calories: 80
  },
  {
    emoji: '🍑',
    type: SnackType.Fruits,
    name: 'Peach',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+peach',
    amount: '1 peach (~150g)',
    calories: 59
  },
  {
    emoji: '🍊',
    type: SnackType.Fruits,
    name: 'Tangerine',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+tangerine',
    amount: '1 tangerine (~88)',
    calories: 47
  },
  {
    emoji: '🍉',
    type: SnackType.Fruits,
    name: 'Watermelon',
    link: 'https://www.wolframalpha.com/input?i=calories+in+watermelon',
    amount: '1 cup (~154g)',
    calories: 46
  },
  {
    emoji: '🥝',
    type: SnackType.Fruits,
    name: 'Kiwi',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+kiwi',
    amount: '1 kiwi (~76g)',
    calories: 46
  },

  {
    emoji: '🍒',
    type: SnackType.Fruits,
    name: 'Cherries',
    link: 'https://www.wolframalpha.com/input?i=calories+in+two+cherries',
    amount: '2 cherries (~16g)',
    calories: 10
  },
  {
    emoji: '🍓',
    type: SnackType.Fruits,
    name: 'Strawberry',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+strawberry',
    amount: '1 strawberry (~12g)',
    calories: 4
  },
  // {
  //   emoji: '🫒',
  //   type: SnackType.Fruits,
  //   name: 'Olive',
  //   link: 'https://www.wolframalpha.com/input?i=calories+in+an+olive',
  //   amount: '1 olive (~3g)',
  //   calories: 3
  // },
  {
    emoji: '🍔',
    type: SnackType.PreparedFood,
    name: 'Hamburger',
    link: 'https://www.wolframalpha.com/input?i=calories+in+hamburger',
    amount: '1 hamburger (~161g)',
    calories: 421
  },
  {
    emoji: '🍕',
    type: SnackType.PreparedFood,
    name: 'Slice of pizza',
    link: 'https://www.wolframalpha.com/input?i=calories+in+slice+of+pizza',
    amount: '1 slice (~143g)',
    calories: 391
  },
  {
    emoji: '🥪',
    type: SnackType.PreparedFood,
    name: 'Sandwich',
    link: 'https://www.fatsecret.com/calories-nutrition/usda/ham-and-cheese-sandwich',
    amount: '1 sandwich (~146g)',
    calories: 352
  },
  {
    emoji: '🍟',
    type: SnackType.PreparedFood,
    name: 'French Fries',
    link: 'https://www.wolframalpha.com/input?i=calories+in+french+fries',
    amount: '1 serving (~134g)',
    calories: 319
  },
  {
    emoji: '🌮',
    type: SnackType.PreparedFood,
    name: 'Taco',
    link: 'https://www.wolframalpha.com/input?i=calories+in+taco',
    amount: '1 taco (~140g)',
    calories: 304
  },
  {
    emoji: '🍝',
    type: SnackType.PreparedFood,
    name: 'Spaghetti',
    link: 'https://www.nutritionix.com/i/nutritionix/spaghetti-with-tomato-sauce-1-cup/56aa868dee6d82ca2b9284c7',
    amount: '1 cup (~248g)',
    calories: 271
  },
  {
    emoji: '🌭',
    type: SnackType.PreparedFood,
    name: 'Hot Dog',
    link: 'https://www.wolframalpha.com/input?i=calories+in+hot+dog',
    amount: '1 hot dog (~106g)',
    calories: 269
  },
  {
    emoji: '🌯',
    type: SnackType.PreparedFood,
    name: 'Burrito',
    link: 'https://www.wolframalpha.com/input?i=calories+in+burrito',
    amount: '1 burrito (~104g)',
    calories: 226
  },
  {
    emoji: '🥞',
    type: SnackType.PreparedFood,
    name: 'Pancakes',
    link: 'https://www.wolframalpha.com/input?i=calories+in+pancakes',
    amount: '1 serving (~116g)',
    calories: 225
  },
  {
    emoji: '🥯',
    type: SnackType.PreparedFood,
    name: 'Bagel',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+bagel',
    amount: '1 bagel (~75g)',
    calories: 207
  },
  {
    emoji: '🥐',
    type: SnackType.PreparedFood,
    name: 'Croissant',
    link: 'https://www.wolframalpha.com/input?i=calories+in+croissant',
    amount: '1 croissant (~57g)',
    calories: 204
  },
  {
    emoji: '🍿',
    type: SnackType.PreparedFood,
    name: 'Popcorn',
    link: 'https://www.wolframalpha.com/input?i=calories+in+popcorn',
    amount: '1 serving (~30g)',
    calories: 136
  },
  {
    emoji: '🥨',
    type: SnackType.PreparedFood,
    name: 'Pretzel',
    link: 'https://www.wolframalpha.com/input?i=calories+in+pretzel',
    amount: '1 pretzel (~30g)',
    calories: 117
  },
  {
    emoji: '🧇',
    type: SnackType.PreparedFood,
    name: 'Waffle',
    link: 'https://www.wolframalpha.com/input?i=calories+in+waffle',
    amount: '1 waffle (~33g)',
    calories: 99
  },
  {
    emoji: '🥓',
    type: SnackType.PreparedFood,
    name: 'Bacon (pan fried)',
    link: 'https://www.wolframalpha.com/input?i=calories+in+crispy+bacon&assumption=%7B%22DPClash%22,+%22ExpandedFoodE%22,+%22bacon%22%7D+-%3E+%7B%22PreparedCuredPorkBacon%22,+%22dflt%22%7D&assumption=%7B%22EAC%22,+%22ExpandedFood%22,+%22PreparedCuredPorkBacon%22%7D+-%3E+%7B%7B%22PreparedCuredPorkBacon%22,+%7B%22Food:CookingMethod%22+-%3E+%22Food:PanFried%22%7D%7D%7D',
    amount: '2 slices (~14g)',
    calories: 76
  },
  // {
  //   emoji: '🍳',
  //   type: SnackType.PreparedFood,
  //   name: 'Fried Egg',
  //   link: 'https://www.wolframalpha.com/input?i=calories+in+fried+egg',
  //   amount: '1 egg (~35g)',
  //   calories: 68
  // },
  {
    emoji: '🥗',
    type: SnackType.Vegetable,
    name: 'Green Salad',
    link: 'https://www.fatsecret.com/calories-nutrition/generic/lettuce-salad-with-avocado-tomato-and-or-carrots-with-or-without-other-vegetables-no-dressing?portionid=23375&portionamount=1.000',
    amount: '1 cup (~86g)',
    calories: 45
  },
  {
    emoji: '🥑',
    type: SnackType.Vegetable,
    name: 'Avocado',
    link: 'https://www.wolframalpha.com/input?i=calories+in+an+half+of+avocado',
    amount: '1/2 avocado (~107g)',
    calories: 159
  },
  {
    emoji: '🥜',
    type: SnackType.Vegetable,
    name: 'Peanuts',
    link: 'https://www.wolframalpha.com/input?i=calories+in+peanuts+15+grams',
    amount: '1 serving (~15g)',
    calories: 84
  },
  {
    emoji: '🥒',
    type: SnackType.Vegetable,
    name: 'Cucumber',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+cucumber',
    amount: '1 cucumber (~201g)',
    calories: 27
  },
  {
    emoji: '🫑',
    type: SnackType.Vegetable,
    name: 'Pepper',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+green+pepper&assumption=%7B%22DPClash%22,+%22ExpandedFoodE%22,+%22green+pepper%22%7D+-%3E+%7B%22SweetGreenPepper%22%7D&assumption=%7B%22EAC%22,+%22ExpandedFood%22,+%7B%22PreparedSweetPepper%22,+%7B%22Food:Variety%22+-%3E+%22Food:Green%22%7D%7D%7D+-%3E+%7B%7B%22a%22,+%7B%22PreparedSweetPepper%22,+%7B%22Food:Variety%22+-%3E+%22Food:Green%22%7D%7D%7D,+%22dflt%22%7D',
    amount: '1 pepper (~119g)',
    calories: 24
  },
  {
    emoji: '🥕',
    type: SnackType.Vegetable,
    name: 'Carrot',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+carrot',
    amount: '1 carrot (~36g)',
    calories: 13
  },
  {
    emoji: '🍅',
    type: SnackType.Vegetable,
    name: 'Tomato',
    link: 'https://www.wolframalpha.com/input?i=calories+in+a+tomato',
    amount: '1 tomato (~117g)',
    calories: 21
  }
]

export function getBeerSnack(): Snack | undefined {
  return snacks.find((snack) => snack.name === 'Beer')
}

export function sortSnacksByCalories(snacksToSort: Snack[] = snacks, descending = true): Snack[] {
  return snacksToSort.sort((a, b) => {
    return descending ? b.calories - a.calories : a.calories - b.calories
  })
}

export function sortSnacksRandomlyByCalories(snacksToSort: Snack[] = snacks): Snack[] {
  return snacksToSort.sort(() => {
    return Math.random() - 0.5
  })
}

export function randomizeSnacksWithinQuartiles(snacksToSort: Snack[] = snacks) {
  const quartileSize = Math.floor(snacksToSort.length / 4)

  const quartiles = [
    snacksToSort.slice(0, quartileSize),
    snacksToSort.slice(quartileSize, 2 * quartileSize),
    snacksToSort.slice(2 * quartileSize, 3 * quartileSize),
    snacksToSort.slice(3 * quartileSize)
  ]

  const randomizedQuartiles = quartiles.map((quartile) => {
    return sortSnacksRandomlyByCalories(quartile)
  })

  const randomizedArray = randomizedQuartiles.flat()

  return randomizedArray
}

function groupSnacksByCalories(snacks: Snack[], threshold = 100): Snack[][] {
  const groupedSnacks: Snack[][] = []

  snacks.forEach((snack) => {
    const groupIndex = groupedSnacks.findIndex((group) => {
      const averageCalories = group.reduce((acc, curr) => acc + curr.calories, 0) / group.length
      return Math.abs(averageCalories - snack.calories) < threshold
    })

    if (groupIndex !== -1) {
      groupedSnacks[groupIndex].push(snack)
    } else {
      groupedSnacks.push([snack])
    }
  })

  return groupedSnacks
}

function randomizeSnacksWithinGroups(groups: Snack[][]): Snack[] {
  const randomizedSnacks: Snack[] = []

  groups.forEach((group) => {
    const shuffledGroup = group.sort(() => Math.random() - 0.5)
    randomizedSnacks.push(...shuffledGroup)
  })

  return randomizedSnacks
}

export function randomizeSnacksWithSimilarCalories(snacksToSort: Snack[] = snacks) {
  const sortedByCalories = sortSnacksByCalories(snacksToSort)
  const snackGroups = groupSnacksByCalories(sortedByCalories)
  const randomizedSnacksWithinGroups = randomizeSnacksWithinGroups(snackGroups)

  return randomizedSnacksWithinGroups
}

export function sortSnacksBySnackType(snacksToSort: Snack[] = snacks): Snack[] {
  return snacksToSort.sort((a, b) => {
    const aOrder = getSnackTypeOrder(a.type)
    const bOrder = getSnackTypeOrder(b.type)

    return aOrder - bOrder
  })
}

const defaultSnackTypeOrder = {
  [SnackType.PreparedFood]: 1,
  [SnackType.Beverages]: 2,
  [SnackType.SweetsAndDessert]: 3,
  [SnackType.Fruits]: 4,
  [SnackType.Vegetable]: 5,
  [SnackType.AsianFood]: 6
}

function getSnackTypeOrder(snackType: SnackType, order = defaultSnackTypeOrder) {
  return order[snackType] || 9999 // rank last if not found
}

export const snacksSortedBySnackTypeAndCalories = (snacksToSort: Snack[] = snacks): Snack[] => {
  const sortedByCalories = sortSnacksByCalories(snacksToSort)
  const sortedBySnackType = [...sortSnacksBySnackType(sortedByCalories)]

  return sortedBySnackType
}
